import styled from "styled-components";

export const Container = styled.div`
  width: ${({ $width }) => $width};
  min-height: ${({ $minHeight }) => $minHeight};
  background-color: ${({ theme }) => theme.modal.background};
  border: ${({ theme }) => theme.modal.border};
  box-shadow: ${({ theme }) => theme.modal.boxShadow};
  border-radius: 24px;
  padding: ${({ $padding }) => $padding};;
  overflow: hidden;

  position: relative;
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    padding: 16px;
    width: 100%;
    height: 592;
    border: none;
    border-top: ${({ theme }) => theme.modal.mobile.borderTop};
    border-radius: 16px 16px 0px 0px;
    place-self: end;
  }
`
